import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import { sectionVariant, showContent } from "../../utils/variants";

import { Homepage, Service } from "../../@types/lang";
import Title from "../shared/Title";

type Props = {
  lang: Homepage;
  services: Service[];
};

const Services = ({ lang, services }: Props) => {
  return (
    <>
      <div className="px-6 lg:px-20">
        <div className="flex items-center justify-between">
          <div className="flex flex-col space-y-4">
            <Title text={lang.service_title} type="p" />
          </div>
          <Link
            to={`/service/${services[0].title.toLowerCase().replace(/\s+/g, "-")}`}
            className="bg-[#504E48] hover:bg-[#504E04] text-center mt-4 w-max rounded-[10px] px-6 py-3 text-white text-xs lg:text-lg cursor-pointer"
          >
            {lang.see_all_btn || "-"}
          </Link>
        </div>
        {/* LIST SERVICE */}
        <motion.div
          variants={sectionVariant}
          initial="hidden"
          whileInView="visible"
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8"
        >
          {services.map((service) => (
            <motion.div
              key={service.id}
              custom={service.id}
              variants={showContent}
              className="border border-solid border-[#A0A0A0] py-6 text-center rounded-[10px] relative z-0 cursor-pointer h-full hover:bg-[#504E48] hover:cursor-pointer transition-all ease-in-out duration-300 group"
            >
              <div className="flex flex-col gap-4 justify-center items-start h-full px-6">
                <div className="flex justify-center group-hover:bg-white group-hover:rounded-full p-1">
                  <div dangerouslySetInnerHTML={{ __html: service.iconUrl }} />
                </div>
                <h3 className="text-base lg:text-lg font-medium text-[#1E1E1E] group-hover:text-white">
                  {service.title}
                </h3>
                <p className="text-sm lg:text-base text-[#A0A0A0] font-normal text-left group-hover:text-[#D4D4D4]">
                  {service.shortDescription}
                </p>
                <Link
                  to={`/service/${service.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[#81B465] text-base font-medium text-left"
                >
                  {lang.read_more_btn} &gt;
                </Link>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </>
  );
};

export default Services;
